import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button, Card, Col, Modal, Row, Tooltip } from "antd";
import { USAMap, USAStateAbbreviation } from "@mirawision/usa-map-react";
import Header from "../../Components/Header";
import Footer from "../../Components/Footer";
import rolloutWebinar from "../../images/workshop/rollout_webinar.png";
import workshopPhoto1 from "../../images/workshop/workshop_photo_1.png";
import tradeshow from "../../images/workshop/tradeshow.png";
import "./style.css";

function Workshops() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [fileToOpen, setFileToOpen] = useState("");

  const workshops = {
    MS: [
      {
        title: "Pontotoc",
        location: "MSU Extension - Pontotoc County",
        address: "402 C.J. Hardin Jr. Drive, Pontotoc, MS 38863",
        coordinates: { lat: 34.25622906247503, lng: -89.02503027440059 },
        date: "11/14/2023",
        time: "9:30 AM – 12:00 PM CST",
        note: "This is an in-person workshop.",
        link: "https://reg.extension.msstate.edu/reg/event_page.aspx?ek=0081-0004-c772ec4b71764c5a9c673e1bf48bc64e",
      },
      {
        title: "Stoneville",
        location: "MSU Delta Research and Extension Center",
        address: "82 Stoneville Rd, Stoneville, MS 38776",
        coordinates: { lat: 33.42297732890887, lng: -90.90924661675558 },
        date: "11/16/2023",
        time: "9:30 AM – 12:00 PM CST",
        note: "This is an in-person workshop.",
        link: "https://reg.extension.msstate.edu/reg/event_page.aspx?ek=0081-0004-aa02e0bc934848ff919caaadf769f299",
      },
      {
        title: "Onward",
        location:
          "Theodore Roosevelt National Wildlife Refuge - Visitor Center",
        address: "5068 US-61, Rolling Fork, MS 39159",
        coordinates: { lat: 32.70462726914907, lng: -90.93182795432807 },
        date: "11/27/2023",
        time: "9:30 AM – 12:00 PM CST",
        note: "This is an in-person workshop.",
        link: "https://reg.extension.msstate.edu/reg/event_page.aspx?ek=0081-0004-fbf4bb309f28498d93e5114417952b6e",
      },
      {
        title: "Tunica",
        location: "Tunica County Museum",
        address: "1 Museum Blvd, Tunica, MS 38676",
        coordinates: { lat: 34.72825985749033, lng: -90.36801117219258 },
        date: "11/29/2023",
        time: "9:30 AM – 12:00 PM CST",
        note: "This is an in-person workshop.",
        link: "https://reg.extension.msstate.edu/reg/event_page.aspx?ek=0081-0004-bfe397240c534cb085091571745952f2",
      },
    ],
    MO: [
      {
        title: "Jackson",
        location:
          "University of Missouri Extension Center of Cape Girardeau County",
        address: "684 Jackson Trail, Jackson, MO 63755",
        coordinates: { lat: 37.36924469988073, lng: -89.66910388667311 },
        date: "12/05/2023",
        time: "9:30 AM – 12:00 PM CST",
        note: "This is an in-person workshop.",
        link: "https://reg.extension.msstate.edu/reg/event_page.aspx?ek=0081-0004-e078d621ad67443896aa60e50f1d7860",
      },
      {
        title: "Fulton",
        location: "Callaway Electric Cooperative",
        address: "1313 Cooperative Dr, Fulton, MO 65251",
        coordinates: { lat: 38.82409929152283, lng: -91.97707610821695 },
        date: "12/11/2023",
        time: "9:30 AM – 12:00 PM CST",
        note: "This is an in-person workshop.",
        link: "https://reg.extension.msstate.edu/reg/event_page.aspx?ek=0081-0004-fb01d72ebc644d9bba14c31028319e24",
      },
      {
        title: "Trenton",
        location: "North Central Missouri College Barton Farm Campus",
        address: "96 S E 8th Ave, Trenton, MO 64683",
        coordinates: { lat: 40.07810190259239, lng: -93.61849017420784 },
        date: "12/12/2023",
        time: "9:30 AM – 12:00 PM CST",
        note: "This is an in-person workshop.",
        link: "https://reg.extension.msstate.edu/reg/event_page.aspx?ek=0081-0004-d8501fbb386a4bd3b02045e740a1dbe6",
      },
      {
        title: "Lamar",
        location: "Thiebaud Auditorum",
        address: "105 E 11th St, Lamar, MO 64759",
        coordinates: { lat: 37.49419019530999, lng: -94.27525041847224 },
        date: "12/13/2023",
        time: "9:30 AM – 12:00 PM CST",
        note: "This is an in-person workshop.",
        link: "https://reg.extension.msstate.edu/reg/event_page.aspx?ek=0081-0004-c2b8acc8ce5d41c4b017d5f6c0722870",
      },
    ],
    IL: [
      {
        title: "Marion",
        location: "Farm Credit Illinois",
        address: "2601 Henry Dr, Marion, IL 62959",
        coordinates: { lat: 37.73250467153018, lng: -88.96150553231814 },
        date: "12/06/2023",
        time: "9:30 AM – 12:00 PM CST",
        note: "This is an in-person workshop.",
        link: "https://reg.extension.msstate.edu/reg/event_page.aspx?ek=0081-0004-86cbd0a9e0c7425a85a0ed627d6921a0",
      },
      {
        title: "Gilman",
        location: "Ford-Iroquois Farm Bureau",
        address: "1381 S Crescent St, Gilman, IL 60938",
        coordinates: { lat: 40.753118846011795, lng: -87.99603346475405 },
        date: "02/06/2024",
        time: "9:30 AM – 12:00 PM CST",
        note: "This is an in-person workshop.",
        link: "https://reg.extension.msstate.edu/reg/event_page.aspx?ek=0081-0004-55a800f8cc4243238ae06022595064bf",
      },
      {
        title: "Sycamore",
        location: "Dekalb County Farm Bureau",
        address: "1350 W Prairie Dr, Sycamore, IL 60178",
        coordinates: { lat: 41.96675841169203, lng: -88.70462984587964 },
        date: "02/07/2024",
        time: "9:30 AM – 12:00 PM CST",
        note: "This is an in-person workshop.",
        link: "https://reg.extension.msstate.edu/s_reg/reg_registration_maintenance.aspx?ek=0081-0004-57c271a635cd42a3803d57979fa86709",
      },
      {
        title: "Quincy",
        location: "Adams County Farm Bureau ",
        address: "330 S 36th St # 2, Quincy, IL 62301",
        coordinates: { lat: 39.929019508490875, lng: -91.35892961713665 },
        date: "02/08/2024",
        time: "9:30 AM – 12:00 PM CST",
        note: "This is an in-person workshop.",
        link: "https://reg.extension.msstate.edu/reg/event_page.aspx?ek=0081-0004-3cfb210432f8462b8cd0b429b0e54b91",
      },
    ],
    IA: [
      {
        title: "Storm Lake",
        location: "Buena Vista County Extension Services ",
        address: "701 Seneca St #1, Storm Lake, IA 50588",
        coordinates: { lat: 42.6457792, lng: -95.1962634 },
        date: "11/12/2024",
        time: "9:30 AM – 11:00 AM",
        note: "This is an in-person workshop.",
        link: "https://reg.extension.msstate.edu/reg/event_page.aspx?ek=0081-0004-0405eaed3714408293a116708df5ed8b",
      },
      {
        title: "Elkader",
        location: "Osborne Visitor Welcome Center 3F ",
        address: "29862 Osborne Rd, Elkader, IA 52043",
        coordinates: { lat: 42.7911721, lng: -91.4454421 },
        date: "11/13/2024",
        time: "9:30 AM – 11:00 AM",
        note: "This is an in-person workshop.",
        link: "https://reg.extension.msstate.edu/reg/event_page.aspx?ek=0081-0004-09c99ed4f2e74ac7a858273ec3c84923",
      },
      {
        title: "Winterset",
        location: "AgriVision Equipment ",
        address: "1200 IA-92, Winterset, IA 50273",
        coordinates: { lat: 41.3433251, lng: -94.0004631 },
        date: "11/14/2024",
        time: "9:30 AM – 11:00 AM",
        note: "This is an in-person workshop.",
        link: "https://reg.extension.msstate.edu/reg/event_page.aspx?ek=0081-0004-1f1f03cb6002410b9960a57bd1a30c8f",
      },
    ],
    IN: [
      {
        title: "Bedford",
        location: "StoneGate Arts and Education Center ",
        address: "931 15th St, Bedford, IN 47421",
        coordinates: { lat: 38.862262, lng: -86.4839257 },
        date: "12/10/2024",
        time: "9:30 AM – 11:00 AM",
        note: "This is an in-person workshop.",
        link: "https://reg.extension.msstate.edu/reg/event_page.aspx?ek=0081-0004-bb71d0cae1ee4262817b3b104eb1d6ec",
      },
      {
        title: "Logansport",
        location: "Cass County Fairgrounds ",
        address: "2281 E County Rd 125 N, Logansport, IN 46947",
        coordinates: { lat: 40.7843513, lng: -86.3322448 },
        date: "12/11/2024",
        time: "9:30 AM – 11:00 AM",
        note: "This is an in-person workshop.",
        link: "https://reg.extension.msstate.edu/reg/event_page.aspx?ek=0081-0004-9ab8196ee6c149d8b73d8728e3ea042f",
      },
    ],
    OH: [
      {
        title: "Tiffin",
        location: "Seneca County Public Safety Building ",
        address: "2636, 126 Hopewell Ave, Tiffin, OH 44883",
        coordinates: { lat: 41.1079673, lng: -83.2014112 },
        date: "12/12/2024",
        time: "9:30 AM – 11:00 AM",
        note: "This is an in-person workshop.",
        link: "https://reg.extension.msstate.edu/reg/event_page.aspx?ek=0081-0004-9cec1a7e1b6243a9941595eed559eeda",
      },
      {
        title: "Urbana",
        location: "Champaign County Farm Service Agency ",
        address: "1512 US-68 N100, Urbana, OH 43078",
        coordinates: { lat: 40.0898817, lng: -83.7577003 },
        date: "12/13/2024",
        time: "9:30 AM – 11:00 AM",
        note: "This is an in-person workshop.",
        link: "https://reg.extension.msstate.edu/reg/event_page.aspx?ek=0081-0004-c2d6bb0749f04afe9ea321efa117a03e",
      },
    ],
  };

  const onSummaryClickAR = () => {
    setFileToOpen("Arkansas.pdf");
    setIsModalOpen(true);
  };

  const onSummaryClickIA = () => {
    setFileToOpen("Iowa.pdf");
    setIsModalOpen(true);
  };

  const onSummaryClickIL = () => {
    setFileToOpen("Illinois.pdf");
    setIsModalOpen(true);
  };

  const onSummaryClickIN = () => {
    setFileToOpen("Indiana.pdf");
    setIsModalOpen(true);
  };

  const onSummaryClickMO = () => {
    setFileToOpen("Missouri.pdf");
    setIsModalOpen(true);
  };

  const onSummaryClickMS = () => {
    setFileToOpen("Mississippi.pdf");
    setIsModalOpen(true);
  };

  const onSummaryClickOH = () => {
    setFileToOpen("Ohio.pdf");
    setIsModalOpen(true);
  };

  const onSummaryClickVR = () => {
    setFileToOpen("Virtual.pdf");
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const customStates = {
    AR: {
      fill: "rgba(128,0,0,0.5)",
      onClick: onSummaryClickAR,
    },
    IA: {
      fill: "rgba(128,0,0,0.5)",
      onClick: onSummaryClickIA,
    },
    IL: {
      fill: "rgba(128,0,0,0.5)",
      onClick: onSummaryClickIL,
    },
    IN: {
      fill: "rgba(128,0,0,0.5)",
      onClick: onSummaryClickIN,
    },
    MO: {
      fill: "rgba(128,0,0,0.5)",
      onClick: onSummaryClickMO,
    },
    MS: {
      fill: "rgba(128,0,0,0.5)",
      onClick: onSummaryClickMS,
    },
    OH: {
      fill: "rgba(128,0,0,0.5)",
      onClick: onSummaryClickOH,
    },
  };

  return (
    <>
      <Header />
      <Row>
        {/* --- PAST EVENTS --- */}
        <Col span={20} offset={2}>
          <h2 className="mt-3 workshop-header">Past Events</h2>
        </Col>

        <Col span={20} offset={2}>
          <Row align="middle" gutter={[24, 24]}>
            {/* Paragraph Column (60% on desktop, 100% on mobile) */}
            <Col xs={24} md={14}>
              <h3>
                After completing our expansion, CRP Menu Tool is fully
                available across 8 states in Arkansas, Illinois, Indiana, Iowa,
                Louisiana, Mississippi, Missouri, and Ohio. We hosted the CRP
                Menu Tool rollout webinars in June and July. 
              </h3>
              <h3>
                The recording of the webinar is available now (click the 
                <a
                  href="https://msstate.webex.com/recordingservice/sites/msstate/recording/dde3e9a06f4043aeb8279fc06a895983/playback"
                  style={{ color: "maroon" }}
                >
                  {" "}video link{" "}
                </a>
                or the picture on the right to watch).
              </h3>
            </Col>

            {/* Image Column (40% on desktop, 100% on mobile) */}
            <Col xs={24} md={10} style={{ textAlign: "center" }}>
              <a
                href="https://msstate.webex.com/recordingservice/sites/msstate/recording/dde3e9a06f4043aeb8279fc06a895983/playback"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={rolloutWebinar}
                  alt="Rollout Webinar Recording"
                  style={{ maxWidth: "100%", height: "auto", borderRadius: "8px" }}
                />
              </a>
            </Col>
          </Row>
        </Col>

        {/* --- PREVIOUS WORKSHOPS --- */}
        <Col span={20} offset={2}>
          <h2 className="mt-3 workshop-header">Previous Workshops</h2>
        </Col>

        <Col span={20} offset={2}>
          <h3>
            Since 2023, we have conducted 19 in-person and 4 virtual workshops
            with local farmers and agencies in seven states: Arkansas, Illinois,
            Indiana, Iowa, Missouri, Mississippi, and Ohio. To view the
            workshop locations and summary, please click each highlighted state
            or view the{" "}
            <a onClick={onSummaryClickVR} style={{ color: "maroon" }}>
              <u>Virtual Workshop Summary</u>
            </a>
            .
          </h3>
        </Col>

        <Col span={20} offset={2}>
          <Row>
            <USAMap customStates={customStates} />
          </Row>
        </Col>

        <Col span={20} offset={2}>
          <div className="workshop-photo-container">
            <img
              className="workshop-photo"
              src={workshopPhoto1}
              alt="Workshop Photo"
            />
            <label className="workshop-photo-label">
              Workshop in Pontotoc, MS
            </label>
          </div>
        </Col>
      </Row>

      {/* Summary PDFs Modal */}
      <Modal
        centered
        title=""
        open={isModalOpen}
        onCancel={handleCancel}
        width="80%"
        footer={null}
      >
        <iframe
          className="embed-responsive-item_basics"
          src={"/Workshops/" + fileToOpen}
          allowFullScreen
        />
      </Modal>

      <Footer />
    </>
  );
}

export default Workshops;